import { createContext, useContext, useState, useEffect } from 'react';

const PrivacyContext = createContext({
  privateMode: false,
  setPrivateMode: () => {}
});

export const usePrivacy = () => useContext(PrivacyContext);

export const PrivacyProvider = ({ children }) => {
  const [privateMode, setPrivateMode] = useState(() => {
    const stored = localStorage.getItem('privateMode');
    return stored ? stored === 'true' : false;
  });

  useEffect(() => {
    localStorage.setItem('privateMode', privateMode);
  }, [privateMode]);

  return (
    <PrivacyContext.Provider value={{ privateMode, setPrivateMode }}>
      {children}
    </PrivacyContext.Provider>
  );
};
